const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

// digit-scramble reveal for stat numbers — locks in left to right like an LED readout settling
function scrambleReveal(el){
  const original = el.textContent;
  const glyphs = '0123456789°CΔ–';
  let frame = 0;
  const total = 12;
  const timer = setInterval(() => {
    frame++;
    if (frame >= total) { el.textContent = original; clearInterval(timer); return; }
    let out = '';
    for (let i = 0; i < original.length; i++) {
      const ch = original[i];
      out += (ch === ' ' || i < frame) ? ch : glyphs[Math.floor(Math.random() * glyphs.length)];
    }
    el.textContent = out;
  }, 45);
}

// fade the page in once styles are ready, instead of a hard flash-on
document.body.classList.add('is-ready');

// stagger the card reveals so each grid cascades in rather than popping at once
document.querySelectorAll('.stat-grid .stat').forEach((el, i) => { el.style.transitionDelay = (i * 0.12) + 's'; });
document.querySelectorAll('.feature-grid .feature').forEach((el, i) => { el.style.transitionDelay = (i * 0.08) + 's'; });

// nav gets a touch more compact and solid once you've scrolled past the hero
(function navScroll(){
  const nav = document.querySelector('.nav');
  if (!nav) return;
  function update(){ nav.classList.toggle('scrolled', window.scrollY > 40); }
  window.addEventListener('scroll', update, { passive:true });
  update();
})();

// product icons tilt gently toward the cursor, and reset on the way out
(function iconTilt(){
  if (reducedMotion) return;
  document.querySelectorAll('.roller-icon, .product-icon, .pad-icon').forEach(icon => {
    icon.addEventListener('mousemove', (e) => {
      const r = icon.getBoundingClientRect();
      const x = (e.clientX - r.left) / r.width - 0.5;
      const y = (e.clientY - r.top) / r.height - 0.5;
      icon.style.transform = 'scale(1.08) rotate(' + (x * 10) + 'deg)';
    });
    icon.addEventListener('mouseleave', () => { icon.style.transform = ''; });
  });
})();

// scroll reveal
const observer = new IntersectionObserver((entries) => {
  entries.forEach(e => {
    if (!e.isIntersecting) return;
    e.target.classList.add('in');
    if (e.target.classList.contains('stat') && !reducedMotion) {
      const num = e.target.querySelector('.num');
      if (num && !num.dataset.scrambled) { num.dataset.scrambled = '1'; scrambleReveal(num); }
    }
  });
}, { threshold: 0.15 });
document.querySelectorAll('.reveal, .stat, .feature').forEach(el => observer.observe(el));

// faq accordion
document.querySelectorAll('.faq-item').forEach(item => {
  const q = item.querySelector('.faq-q');
  const a = item.querySelector('.faq-a');
  q.addEventListener('click', () => {
    const isOpen = item.classList.contains('open');
    document.querySelectorAll('.faq-item.open').forEach(o => {
      if (o !== item) { o.classList.remove('open'); o.querySelector('.faq-a').style.maxHeight = null; }
    });
    if (isOpen) { item.classList.remove('open'); a.style.maxHeight = null; }
    else { item.classList.add('open'); a.style.maxHeight = a.scrollHeight + 'px'; }
  });
});

// buy section: thumbnail gallery swap
(function buyGallery(){
  const stage = document.getElementById('buy-stage-img');
  const thumbs = document.querySelectorAll('.buy-thumb');
  if (!stage || !thumbs.length) return;

  // preload the full-size versions so swapping is instant
  thumbs.forEach(t => { const pre = new Image(); pre.src = t.dataset.full; });

  thumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
      const src = thumb.dataset.full;
      if (!src || stage.src === src) return;
      thumbs.forEach(t => t.classList.remove('is-active'));
      thumb.classList.add('is-active');
      const alt = thumb.querySelector('img');
      stage.classList.add('is-swapping');
      const swap = () => {
        stage.src = src;
        if (alt) stage.alt = alt.alt;
        stage.classList.remove('is-swapping');
      };
      if (reducedMotion) swap();
      else setTimeout(swap, 150);
    });
  });
})();

// ---------- cart plumbing ----------

// Buy Now SETS the cryopod line quantity rather than adding to it. /cart/add.js is
// cumulative, so clicking Buy Now three times used to leave three units in the cart and
// send you to checkout without ever showing you. /cart/update.js takes absolute
// quantities and leaves every other line item alone.
(function buyNowSetsQuantity(){
  const form = document.getElementById('cryopod-buy-form');
  if (!form) return;
  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    const btn = form.querySelector('button[type="submit"]');
    const id = form.querySelector('input[name="id"]').value;
    const qtyEl = form.querySelector('input[name="quantity"]');
    const qty = Math.max(1, parseInt(qtyEl && qtyEl.value, 10) || 1);
    if (btn) { btn.disabled = true; btn.dataset.label = btn.textContent; btn.textContent = 'Adding…'; }
    try {
      const res = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ updates: { [id]: qty } })
      });
      if (!res.ok) throw new Error('cart update failed');
      window.location.href = '/cart';
    } catch (err) {
      // fall back to the plain form POST (return_to sends them to /cart)
      if (btn) { btn.disabled = false; if (btn.dataset.label) btn.textContent = btn.dataset.label; }
      form.submit();
    }
  });
})();

// Cart page: quantity steppers, remove, and cross-sell adds, all without a full reload.
// Re-renders this section from the Section Rendering API so Liquid stays the one place
// prices and totals are calculated.
(function cartPage(){
  if (!document.getElementById('cart-page')) return;
  document.documentElement.classList.add('cart-js');

  let busy = false;

  // Section id is template-scoped (e.g. "template--21247993053375__main"), so read it off
  // the wrapper Shopify renders rather than hardcoding it.
  function sectionId(){
    const wrap = document.getElementById('cart-page');
    const outer = wrap && wrap.closest('[id^="shopify-section-"]');
    return outer ? outer.id.replace('shopify-section-', '') : null;
  }

  async function refresh(){
    const id = sectionId();
    let replaced = false;
    if (id) {
      const res = await fetch('/cart?section_id=' + encodeURIComponent(id), { headers: { 'Accept': 'text/html' } });
      if (res.ok) {
        const html = await res.text();
        const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('#cart-page');
        const current = document.getElementById('cart-page');
        if (fresh && current) { current.replaceWith(fresh); replaced = true; }
      }
    }
    // Never leave stale prices on screen — a cart showing the wrong total is worse
    // than a reload, so fall back to one if the partial re-render didn't happen.
    if (!replaced) { window.location.reload(); return; }
    updateHeaderCount();
  }

  async function updateHeaderCount(){
    const link = document.querySelector('.cart-link');
    if (!link) return;
    try {
      const cart = await (await fetch('/cart.js', { headers: { 'Accept': 'application/json' } })).json();
      link.textContent = cart.item_count > 0 ? 'Cart (' + cart.item_count + ')' : 'Cart';
    } catch (e) { /* leave the server-rendered count alone */ }
  }

  async function post(url, body){
    if (busy) return;
    busy = true;
    document.getElementById('cart-page').classList.add('is-busy');
    try {
      const res = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      });
      if (!res.ok) throw new Error('cart request failed');
      await refresh();
    } catch (err) {
      window.location.reload();
    } finally {
      busy = false;
    }
  }

  // change.js takes a 1-based line number, which survives a variant appearing twice
  const setLine = (line, quantity) => post('/cart/change.js', { line: Number(line), quantity: quantity });

  document.addEventListener('click', (e) => {
    const remove = e.target.closest('[data-cart-remove]');
    if (remove) { e.preventDefault(); setLine(remove.dataset.line, 0); return; }

    const step = e.target.closest('[data-cart-up], [data-cart-down]');
    if (step) {
      e.preventDefault();
      const wrap = step.closest('[data-cart-qty]');
      const input = wrap.querySelector('.qty-input');
      const delta = step.hasAttribute('data-cart-up') ? 1 : -1;
      const next = Math.max(0, (parseInt(input.value, 10) || 0) + delta);
      setLine(wrap.dataset.line, next);
    }
  });

  document.addEventListener('change', (e) => {
    const input = e.target.closest('[data-cart-qty] .qty-input');
    if (!input) return;
    const wrap = input.closest('[data-cart-qty]');
    setLine(wrap.dataset.line, Math.max(0, parseInt(input.value, 10) || 0));
  });

  document.addEventListener('submit', (e) => {
    const form = e.target.closest('.cross-add-form');
    if (!form) return;
    e.preventDefault();
    const id = form.querySelector('input[name="id"]').value;
    post('/cart/add.js', { items: [{ id: Number(id), quantity: 1 }] });
  });
})();

// buy section: quantity stepper
(function qtyStepper(){
  document.querySelectorAll('[data-qty]').forEach(wrap => {
    const input = wrap.querySelector('.qty-input');
    if (!input) return;
    const min = parseInt(input.min, 10) || 1;
    const max = parseInt(input.max, 10) || 99;
    const step = (delta) => {
      const next = Math.min(max, Math.max(min, (parseInt(input.value, 10) || min) + delta));
      input.value = next;
    };
    wrap.querySelector('[data-qty-down]').addEventListener('click', () => step(-1));
    wrap.querySelector('[data-qty-up]').addEventListener('click', () => step(1));
    input.addEventListener('change', () => step(0));
  });
})();

// thermometer rail: ambient scale +25C to -5C, with a glowing band across Cryopod's 0-18C range
(function buildRail(){
  const track = document.getElementById('rail-track');
  if (!track) return;
  const top = 25, bottom = -5;
  for (let t = top; t >= bottom; t -= 3) {
    const pct = (top - t) / (top - bottom) * 100;
    const tick = document.createElement('div');
    tick.className = 'rail-tick';
    tick.style.top = pct + '%';
    track.appendChild(tick);
    if (t % 6 === 1 || t === top || t === bottom) {
      const label = document.createElement('div');
      label.className = 'rail-label';
      label.style.top = pct + '%';
      label.textContent = (t > 0 ? '+' : '') + t + '°';
      track.appendChild(label);
    }
  }
  const bandTopPct = (top - 18) / (top - bottom) * 100;
  const bandBottomPct = (top - 0) / (top - bottom) * 100;
  const band = document.createElement('div');
  band.className = 'rail-band';
  band.style.top = bandTopPct + '%';
  band.style.height = (bandBottomPct - bandTopPct) + '%';
  track.appendChild(band);
  const bandLabel = document.createElement('div');
  bandLabel.className = 'rail-band-label';
  bandLabel.style.top = (bandTopPct + bandBottomPct) / 2 + '%';
  bandLabel.textContent = 'CRYOPOD 0–18°C';
  track.appendChild(bandLabel);
})();

// live telemetry jitter
(function telemetry(){
  const podTemp = document.getElementById('pod-temp');
  const tmTemp = document.getElementById('tm-temp');
  const tmBatt = document.getElementById('tm-batt');
  const tmRuntime = document.getElementById('tm-runtime');
  let battery = 91, runtimeMin = 6*60 + 40;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduced) return;
  setInterval(() => {
    const t = (5.8 + Math.random() * 0.4).toFixed(1);
    if (podTemp) podTemp.textContent = t + '°C';
    if (tmTemp) tmTemp.textContent = t + '°C';
    runtimeMin = Math.max(0, runtimeMin - 1);
    const h = Math.floor(runtimeMin / 60), m = runtimeMin % 60;
    if (tmRuntime) tmRuntime.textContent = h + 'h ' + String(m).padStart(2,'0') + 'm';
    if (Math.random() < 0.1 && battery > 20) { battery -= 1; if (tmBatt) tmBatt.textContent = battery + '%'; }
  }, 2600);
})();

// device interactions: click to open the lid, cursor tilt, and a one-time auto demo in the hero
(function deviceInteractions(){
  const wraps = document.querySelectorAll('.device-wrap');
  wraps.forEach((wrap, i) => {
    const deviceEl = wrap.querySelector('.device');
    const toggle = wrap.parentElement.querySelector('.device-toggle');
    const glow = wrap.parentElement.querySelector('.device-glow');
    function setOpen(isOpen){
      wrap.classList.toggle('open', isOpen);
      if (toggle) {
        toggle.textContent = isOpen ? 'Close lid' : 'Open lid';
        toggle.setAttribute('aria-expanded', String(isOpen));
      }
      if (isOpen && glow && !reducedMotion) {
        glow.classList.add('flash');
        setTimeout(() => glow.classList.remove('flash'), 800);
      }
    }
    if (toggle) toggle.addEventListener('click', () => setOpen(!wrap.classList.contains('open')));
    if (!reducedMotion) {
      wrap.addEventListener('mousemove', (e) => {
        const rect = wrap.getBoundingClientRect();
        const px = (e.clientX - rect.left) / rect.width - 0.5;
        const py = (e.clientY - rect.top) / rect.height - 0.5;
        deviceEl.style.transform = 'rotateY(' + (px * 16) + 'deg) rotateX(' + (-py * 12) + 'deg)';
      });
      wrap.addEventListener('mouseleave', () => { deviceEl.style.transform = ''; });
      if (i === 0) {
        setTimeout(() => { setOpen(true); setTimeout(() => setOpen(false), 2200); }, 1400);
      }
    }
  });
})();

// frost-spark burst on primary button clicks
(function sparkBurst(){
  if (reducedMotion) return;
  function spawn(x, y){
    const count = 14;
    for (let i = 0; i < count; i++){
      const p = document.createElement('span');
      p.className = 'spark-particle';
      const angle = (Math.PI * 2 * i) / count + Math.random() * 0.4;
      const dist = 40 + Math.random() * 50;
      p.style.setProperty('--dx', Math.cos(angle) * dist + 'px');
      p.style.setProperty('--dy', Math.sin(angle) * dist + 'px');
      p.style.left = x + 'px';
      p.style.top = y + 'px';
      document.body.appendChild(p);
      p.addEventListener('animationend', () => p.remove());
    }
  }
  document.querySelectorAll('.btn-primary').forEach(btn => {
    btn.addEventListener('click', (e) => spawn(e.clientX, e.clientY));
  });
})();

// magnetic pull on buttons — nudges toward the cursor within its own bounds
(function magneticButtons(){
  if (reducedMotion) return;
  document.querySelectorAll('.btn').forEach(btn => {
    btn.addEventListener('mousemove', (e) => {
      const r = btn.getBoundingClientRect();
      const x = e.clientX - r.left - r.width / 2;
      const y = e.clientY - r.top - r.height / 2;
      btn.style.transform = 'translate(' + (x * 0.15) + 'px, ' + (y * 0.25) + 'px)';
    });
    btn.addEventListener('mouseleave', () => { btn.style.transform = ''; });
  });
})();

// hero cursor spotlight
(function spotlight(){
  const hero = document.getElementById('hero');
  const spot = document.getElementById('hero-spotlight');
  if (!hero || !spot || reducedMotion) return;
  hero.addEventListener('mousemove', (e) => {
    const rect = hero.getBoundingClientRect();
    spot.style.left = (e.clientX - rect.left) + 'px';
    spot.style.top = (e.clientY - rect.top) + 'px';
  });
})();

// scroll progress bar
(function scrollProgress(){
  const bar = document.getElementById('scroll-progress-bar');
  if (!bar) return;
  function update(){
    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    const height = document.documentElement.scrollHeight - document.documentElement.clientHeight;
    bar.style.width = (height > 0 ? (scrollTop / height) * 100 : 0) + '%';
  }
  window.addEventListener('scroll', update, { passive:true });
  window.addEventListener('resize', update);
  update();
})();

// ambient frost particles
(function frost(){
  const canvas = document.getElementById('frost-canvas');
  if (!canvas) return;
  const ctx = canvas.getContext('2d');
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  let w, h, particles = [];
  function size(){
    w = canvas.width = canvas.offsetWidth;
    h = canvas.height = canvas.offsetHeight;
  }
  function init(){
    size();
    const count = Math.min(70, Math.floor(w / 22));
    particles = Array.from({ length: count }, () => ({
      x: Math.random() * w,
      y: Math.random() * h,
      r: Math.random() * 1.6 + 0.4,
      s: Math.random() * 0.25 + 0.05,
      o: Math.random() * 0.5 + 0.15
    }));
  }
  function draw(){
    ctx.clearRect(0, 0, w, h);
    ctx.fillStyle = '#8fe6ff';
    particles.forEach(p => {
      ctx.globalAlpha = p.o;
      ctx.beginPath();
      ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
      ctx.fill();
      if (!reduced) {
        p.y -= p.s;
        if (p.y < -4) { p.y = h + 4; p.x = Math.random() * w; }
      }
    });
    ctx.globalAlpha = 1;
    if (!reduced) requestAnimationFrame(draw);
  }
  window.addEventListener('resize', init);
  init();
  draw();
})();
